import { useQuery } from '@tanstack/react-query';

import { Chain } from '~/components/Vendors/Chains/types';

import ReservationService from '~/services/ReservationService';

export const chainQueryKeys = {
  all: ['chains'] as const,
  list: (name?: string) => [...chainQueryKeys.all, 'list', name ?? ''] as const,
  detail: (chainId: string) => [...chainQueryKeys.all, 'detail', chainId] as const,
};

interface ChainsResponse {
  status: number;
  result: Chain[];
}

export function useGetChains(name?: string) {
  return useQuery<Chain[]>({
    queryKey: chainQueryKeys.list(name),
    queryFn: async () => {
      const res: ChainsResponse = await ReservationService.getChains(name ? { name } : undefined);
      return res.result ?? [];
    },
  });
}
